export default "//file.bilionpass.com/japandx-portal/0.1.17/static/img/combination-select-arrow.b538bef5-9110d1.svg";